import { RadioChangeEvent } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { url } from "config/constants";
import { optionsGet, optionsPost, swalWarning } from "config/methods";
import { useEffect, useState } from "react";

export type VisorReporteOrdenCompra = {
  COD: number;
  Descripcion: string;
  LAB: string;
  PVP: number;
  Costo: number;
  MrgB: number;
  PVPxMia: number;
  Descu_Mia: number;
  Margen_Mia: number;
  PVPxSG: number;
  Descu_SG: number;
  Margen_SG: number;
  VENTA_MIA: number;
  VENTA_SG: number;
  MAX_Mia: number;
  MAX_SG: number;
  Pedir_Mia: number;
  Pedir_Sg: number;
  Stock_Mia: number;
  Stock_Sg: number;
  G: string;
  R: string;
  P: string;
  PMAC: string;
  C: string;
  Cod_Producto: number;
  key: React.Key;
  Cod_Proveedor: number;
  Proveedor: string;
  Cantidad: number;
  Boni_Mia: number;
  Boni_Sg: number;
  Descu: number;
  PVF: number;
  S_B_Machala: number;
  S_B_Portoviejo: number;
  Master_Pack: number;
  Suge_M: number;
  Suge_P: number;
  Costo_Proveedor: number;
  IVA: number;
};

export type ListOrdenCompra = {
  key: React.Key;
  Cod_Proveedor: number;
  cadena: string;
  Proveedor: string;
  Valor: number;
};

export default function useGenerarOrden(SumProveedorOrdenCompra: Function) {
  const [Fecha, setFecha] = useState();
  const [PedirMatriz, setPedirMatriz] = useState(true);
  const [ModoAccion, setModoAccion] = useState(1);
  const [FechaDevolucion, setFechaDevolucion] = useState();
  const [DiasMinimos, setDiasMinimos] = useState("20");
  const [DiasMaximos, setDiasMaximos] = useState("30");
  const [TipoSugerido, setTipoSugerido] = useState("laboratorio");
  const [Laboratorio, setLaboratorio] = useState<String[]>();
  const [dataLaboratorio, setdataLaboratorio] = useState([{ label: "Seleccione un Laboratorio", value: "" }]);
  const [LineasLaboratorio, setLineasLaboratorio] = useState<string[]>();
  const [DataLineaLaboratorio, setDataLineaLaboratorio] = useState([
    { label: "Seleccione una Linea laboratorio", value: "" },
  ]);
  const [Proveedores, setProveedores] = useState("");
  const [BajoStock, setBajoStock] = useState(false);
  const [MinA, setMinA] = useState("20");
  const [MaxA, setMaxA] = useState("50");
  const [MinB, setMinB] = useState("20");
  const [MaxB, setMaxB] = useState("50");
  const [MinC, setMinC] = useState("20");
  const [MaxC, setMaxC] = useState("50");
  const [openModal, setOpenModal] = useState(false);
  const [dataProductos, setdataProductos] = useState([{ label: "Seleccione un Producto", value: "" }]);
  const [productos, setproductos] = useState<String[]>();
  const [dataBodega, setdataBodega] = useState([{ label: "Seleccione una Bodega", value: "" }]);
  const [Bodega, setBodega] = useState("");
  const [openLaboratorio, setopenLaboratorio] = useState(false);
  const [openLineas, setopenLineas] = useState(false);
  const [LoaderOrdCom, setLoaderOrdCom]= useState(false)

  const getLaboratorio = async () => {
    setLoaderOrdCom(true)
    try {
      const result = await fetch(`${url}fapifsg-pr/compras/ordencompra/getLaboratorios`, optionsGet()).then((data) =>
        data.json()
      );
      //console.log(result)
      let newget: { label: string; value: string }[] = [];
      result.forEach((item: any) => {
        let add = {
          value: item.Id,
          label: item.Nombre,
        };
        newget = [...newget, add];
      });
      setdataLaboratorio(newget);
    } catch (error) {}
  };

  const getProductos = async () => {
    try {
      const result = await fetch(`${url}fapifsg-pr/compras/ordencompra/getProducto`, optionsGet()).then((data) =>
        data.json()
      );
      //console.log(result)
      let newget: { label: string; value: string }[] = [];
      result.forEach((item: any) => {
        let add = {
          value: item.Id,
          label: item.Descripcion,
        };
        newget = [...newget, add];
      });
      setdataProductos(newget);
    } catch (error) {}
  };

  const getLineaLaboratorio = async () => {
    try {
      const result = await fetch(`${url}fapifsg-pr/compras/ordencompra/getLineasLaboratorios`, optionsGet()).then((data) =>
        data.json()
      );
      //console.log(result)
      let newget: { label: string; value: string }[] = [];
      result.forEach((item: any) => {
        let add = {
          value: item.Id,
          label: item.Nombre,
        };
        newget = [...newget, add];
      });

      setDataLineaLaboratorio(newget)
      setLoaderOrdCom(false)
    } catch (error) {}
  };

  const getBodegas = async () => {
    try {
      const result = await fetch(`${url}fapifsg-pr/compras/ordencompra/getBodegas`, optionsGet()).then((data) =>
        data.json()
      );
      //console.log(result)
      let newget: { label: string; value: string }[] = [];
      result.forEach((item: any) => {
        let add = {
          value: item.Id,
          label: item.Nombre,
        };
        newget = [...newget, add];
      });
      setdataBodega(newget);
    } catch (error) {}
  };

  const onChangeBodega = (value: string) => {
    setBodega(value);
    //console.log(`selected ${value}`);
  };

  const onChangeLineasLab = (value: string[]) => {
    setLineasLaboratorio(value);
    setopenLineas(false);
    //console.log(`selected ${value}`);
  };

  const onChangeLaboratorio = async (value: string[]) => {
    setLaboratorio(value);
    setopenLaboratorio(false);
    let newget: string[] = [];
    if (value.length > 0) {
      const result = await fetch(
        `${url}fapifsg-pr/compras/ordencompra/getLineasporLab`,
        optionsPost({ Laboratorios: value })
      ).then((data) => data.json());
      if (result.length > 0) {
        result.forEach((item: any) => {
          let add = [item.Id];
          newget = [...newget, ...add];
        });
      }
    }
    setLineasLaboratorio(newget);
  };

  const onChangeProductos = (value: string[]) => {
    setproductos(value);
    //console.log(`selected ${value}`);
  };

  useEffect(() => {
    getLaboratorio();
    getLineaLaboratorio();
    getProductos();
  }, []);

  const SoloNumeros = (e: any, nombrefuntion: Function, categoria: String = "") => {
    let newValue = e.target.value;
    //console.log(newValue)
    if (/^[0-9]{0,10}$/.test(newValue)) {
      nombrefuntion(newValue);
    }
  };

  const onChangeDiasMinimos = (e: any) => {
    let newValue = e.target.value;
    if (!newValue) {
      setDiasMinimos("0");
      setMinA("0");
      setMinB("0");
      setMinC("0");
      return;
    }
    if (/^[0-9]{0,10}$/.test(newValue)) {
      setDiasMinimos(newValue);
      setMinA(newValue);
      setMinB(newValue);
      setMinC(newValue);
    }
  };

  const onChangeDiasMaximos = (e: any) => {
    let newValue = e.target.value;
    if (!newValue) {
      setDiasMaximos("0");
      setMaxA("0");
      setMaxB("0");
      setMaxC("0");
      return;
    }
    if (/^[0-9]{0,10}$/.test(newValue)) {
      setDiasMaximos(newValue);
      setMaxA(newValue);
      setMaxB(newValue);
      setMaxC(newValue);
    }
  };

  const onchangeFecha = (dates: any, dateStrings: any) => {
    setFecha(dates);
  };

  const onchangeFechaDevolucion = (dates: any, dateStrings: any) => {
    setFechaDevolucion(dates);
  };

  const onchangePedirMatriz = (e: CheckboxChangeEvent) => {
    setPedirMatriz(e.target.checked);
  };

  const onchangeBajoStock = (e: CheckboxChangeEvent) => {
    setBajoStock(e.target.checked);
  };

  const onChangeModoAccion = (e: RadioChangeEvent) => {
    setModoAccion(e.target.value);
  };

  const onChangeTipoSugerido = (value: string) => {
    setTipoSugerido(value);
    if (value === "laboratorio") {
      getLaboratorio();
      getLineaLaboratorio();
    } else {
      getProductos();
    }
  };

  const onChangeProveedores = (e: any) => {
    let newValue = e.target.value;
    //console.log(newValue)
    setProveedores(newValue);
  };

  const btnGenerarOrden = async (setOpenModalGen: Function, setdataProductosOrden: Function) => {
    setLoaderOrdCom(true)
    const result = await fetch(
      `${url}fapifsg-pr/compras/ordencompra/getProductosOrden`,
      optionsPost({
        Lineas_Laboratorios: LineasLaboratorio?.toString(),
        DMinA: MinA,
        DMaxA: MaxA,
        DMinB: MinB,
        DMaxB: MaxB,
        DMinC: MinC,
        DMaxC: MaxC,
      })
    ).then((data) => data.json());
    console.log(result);
    let newdata: any = [];
    if (result) {
      //setestado(true)
      newdata = Array.from(result).map((item: any, key: any) => {
        let Sugerido_Mia: number = 0;
        let porcentaje_mia: number = 0;
        let sugerido_final_mia: number = 0;
        let num_promo_sg: number = 0;
        let num_promo_mia: number = 0;
        let Bonificacion_Sg: number = 0;
        let Bonificacion_Mia: number = 0;
        let Sugerido_Sg: number = 0;
        let porcentaje_sg: number = 0;
        let sugerido_final_Sg: number = 0;
        let porcentaje_promo_Sg: number = 0;
        let porcentaje_promo_Mia: number = 0;

        if (item.Pedir_Mia > 0) {
          Sugerido_Mia = item.Pedir_Mia;
        }
        Sugerido_Mia = Sugerido_Mia + (item.VENTA_MIA / 30) * Number(MaxA) - item.S_B_Machala;
        porcentaje_mia = (item.Master_Pack * Number((Sugerido_Mia / item.Master_Pack + 0.5).toFixed(0))) / Sugerido_Mia - 1;

        if ((porcentaje_mia < 0.25 && porcentaje_mia >= 0) || (porcentaje_mia > -0.05 && porcentaje_mia < 0)) {
          sugerido_final_mia = item.Master_Pack * Math.round(Sugerido_Mia / item.Master_Pack + 0.5);
        } else {
          sugerido_final_mia = Sugerido_Mia;
        }

        if (item.Pedir_Sg > 0) {
          Sugerido_Sg = item.Pedir_Sg;
        }
        Sugerido_Sg = Sugerido_Sg + (item.VENTA_SG / 30) * Number(MaxA) - item.S_B_Portoviejo;
        porcentaje_sg = (item.Master_Pack * Math.round(Sugerido_Sg / item.Master_Pack + 0.5)) / Sugerido_Sg - 1;

        if ((porcentaje_sg < 0.25 && porcentaje_sg >= 0) || (porcentaje_sg > -0.05 && porcentaje_sg < 0)) {
          sugerido_final_Sg = item.Master_Pack * Math.round(Sugerido_Sg / item.Master_Pack + 0.5);
        } else {
          sugerido_final_Sg = Sugerido_Sg;
        }

        if (
          sugerido_final_Sg > 0 &&
          item.Cantidad > 0 &&
          item.Boni > 0 &&
          ((sugerido_final_Sg % item.Master_Pack === 0 && sugerido_final_Sg % (item.Cantidad + item.Boni) === 0) ||
            item.Master_Pack === 1 ||
            sugerido_final_Sg % item.Master_Pack !== 0)
        ) {
          num_promo_sg = Math.round(sugerido_final_Sg / (item.Cantidad + item.Boni) + 0.5);
          porcentaje_promo_Sg = (num_promo_sg * item.Cantidad + num_promo_sg * item.Boni) / sugerido_final_Sg - 1;

          if (
            (porcentaje_promo_Sg < 0.25 && porcentaje_promo_Sg >= 0) ||
            (porcentaje_promo_Sg > -0.05 && porcentaje_promo_Sg < 0)
          ) {
            sugerido_final_Sg = num_promo_sg * item.Cantidad;
            Bonificacion_Sg = num_promo_sg * item.Boni;
          }

          //console.log('sugerido_final_Sg', sugerido_final_Sg,'Bonificacion_Sg', Bonificacion_Sg)
        }

        if (
          sugerido_final_mia > 0 &&
          item.Cantidad > 0 &&
          item.Boni > 0 &&
          ((sugerido_final_mia % item.Master_Pack === 0 && sugerido_final_mia % (item.Cantidad + item.Boni) === 0) ||
            item.Master_Pack === 1 ||
            sugerido_final_mia % item.Master_Pack !== 0)
        ) {
          num_promo_mia = Math.round(sugerido_final_mia / (item.Cantidad + item.Boni) + 0.1);
          porcentaje_promo_Mia = (num_promo_mia * item.Cantidad + num_promo_mia * item.Boni) / sugerido_final_mia - 1;
          if (
            (porcentaje_promo_Mia < 0.25 && porcentaje_promo_Mia >= 0) ||
            (porcentaje_promo_Mia > -0.05 && porcentaje_promo_Mia < 0)
          ) {
            sugerido_final_mia = Math.round(num_promo_mia * item.Cantidad);
            Bonificacion_Mia = Math.round(num_promo_mia * item.Boni);
          }
          //console.log('sugerido_final', sugerido_final,'Bonificacion_Mia', Bonificacion_Mia)
        }

        return {
          key: key + 1,
          COD: item.COD,
          Descripcion: item.Descripcion,
          LAB: item.LAB,
          PVP: item.PVP,
          Costo: item.Costo,
          MrgB: item.MrgB,
          PVPxMia: item.PVPxMia,
          Descu_Mia: item.Descu_Mia,
          Margen_Mia: item.Margen_Mia,
          PVPxSG: item.PVPxSG,
          Descu_SG: item.Descu_SG,
          Margen_SG: item.Margen_SG,
          VENTA_MIA: item.VENTA_MIA,
          VENTA_SG: item.VENTA_SG,
          MAX_Mia: item.MAX_Mia,
          MAX_SG: item.MAX_SG,
          Pedir_Mia: sugerido_final_mia>0?sugerido_final_mia.toFixed(0):0,
          Pedir_Sg: sugerido_final_Sg>0?sugerido_final_Sg.toFixed(0):0,
          Stock_Mia: item.Stock_Mia,
          Stock_Sg: item.Stock_Sg,
          G: item.G,
          R: item.R,
          P: item.P,
          PMAC: item.PMAC,
          C: item.C,
          Cod_Producto: item.key,
          Cod_Proveedor: Number(item.Cod_Proveedor),
          Proveedor: item.Proveedor,
          Cantidad: item.Cantidad,
          Boni_Mia: Bonificacion_Mia,
          Boni_Sg: Bonificacion_Sg,
          Descu: item.Descu,
          PVF: item.PVF,
          S_B_Machala: item.S_B_Machala,
          S_B_Portoviejo: item.S_B_Portoviejo,
          Master_Pack: item.Master_Pack,
          Suge_M: Sugerido_Mia > 0 ? Sugerido_Mia.toFixed(0) : 0,
          Suge_P: Sugerido_Sg > 0 ? Sugerido_Sg.toFixed(0) : 0,
          Costo_Proveedor: item.Costo_Proveedor,
          IVA: item.Iva,
        };
      });
    } else {
      setOpenModalGen(false);
      swalWarning({ text: "No hay datosa" });
    }
    setdataProductosOrden(newdata);
    SumProveedorOrdenCompra(newdata);
    setLoaderOrdCom(false)
    //closemodal(false)
    setOpenModalGen(false);
    //console.log(LineasLaboratorio)
    //setOpenModal(true)
    /*       if(Fecha&&ModoAccion&&FechaDevolucion&&BajoStock&&Proveedores&&DiasMinimos&&DiasMaximos&&MinA&&MinB&&MinC&&MaxA&&MaxB&&MaxC&&(Laboratorio||LineasLaboratorio||Proveedores)){
        if((DiasMinimos>DiasMaximos) || (MinA>MaxA) || (MinB>MaxB) || (MinC>MaxC)){ swalWarning({text:'Los valores de dias mínimos no pueden ser mayores a los de dias máximos'}) }
        if((DiasMaximos<DiasMinimos) || (MaxA<MinA) || (MaxB<MinB) || (MaxC<MinC)){ swalWarning({text:'Los valores de dias máximos no pueden ser menores a los de dias mínimos'})}
        swalQuestion({
          text: "Esta seguro de generar la orden de compra?",
          icon: "warning",
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            return
          }
        })
      }
      else {
        swalWarning({text:'Faltan datos para Generar la Orden'})
      } */
  };

  useEffect(() => {
    getBodegas();
  }, []);

  return {
    SoloNumeros,
    DiasMinimos,
    setDiasMinimos,
    DiasMaximos,
    setDiasMaximos,
    MinA,
    setMinA,
    MinB,
    setMinB,
    MinC,
    setMinC,
    MaxA,
    setMaxA,
    MaxB,
    setMaxB,
    MaxC,
    setMaxC,
    onchangeFecha,
    Fecha,
    onchangeFechaDevolucion,
    FechaDevolucion,
    PedirMatriz,
    onchangePedirMatriz,
    onChangeModoAccion,
    ModoAccion,
    onChangeTipoSugerido,
    TipoSugerido,
    onchangeBajoStock,
    BajoStock,
    onChangeLaboratorio,
    Laboratorio,
    onChangeProveedores,
    Proveedores,
    btnGenerarOrden,
    openModal,
    setOpenModal,
    onChangeDiasMinimos,
    onChangeDiasMaximos,
    dataLaboratorio,
    DataLineaLaboratorio,
    onChangeLineasLab,
    dataProductos,
    onChangeProductos,
    productos,
    dataBodega,
    onChangeBodega,
    Bodega,
    LineasLaboratorio,
    openLaboratorio, setopenLaboratorio,
    openLineas,setopenLineas,
    LoaderOrdCom
  }
}
